// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hP1i","col":"styles_col__PkkIA"};